module.exports = __webpack_public_path__ + "img/icon-tskc.cd6513b5.png";